import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import AlertDetail from './alertDetail';

import {
  getNSAlertDetailsListData,
  postNSHitsUserFeedback
} from '../../../redux/actions/ns/runInstance';
import { getNSGlobalSettingsPageInfo } from '../../../redux/actions/settings';
import {
  getAMLSCommonAlertDetails,
  getAMLSCommonAlertPartyIdentity
} from '../../../redux/actions/common';
import {
  sendToCMAlerts,
  downloadSelectedAlerts
} from '../../../redux/actions/ns/investigation';

function mapStateToProps(state) {
  return {
    settings: state.settings,
    runInstance: state.nsRunInstanceConfig,
    authentication: state.authentication,
    nsInvestigation: state.nsInvestigation,
    amlsCommon: state.amlsCommon
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        getNSGlobalSettingsPageInfo,
        getNSAlertDetailsListData,
        postNSHitsUserFeedback,
        downloadSelectedAlerts,
        sendToCMAlerts,
        getAMLSCommonAlertDetails,
        getAMLSCommonAlertPartyIdentity
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertDetail);
